// src/pages/Login.js
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { apiUrl, getStoredAdmin, getStoredToken, setStoredAuth } from '../config/api';

export default function Login() {
  const [phone, setPhone] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getStoredAdmin() && getStoredToken()) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const requestOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch(apiUrl('request_otp'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone }),
      });
      const data = await res.json();
      if (data.status === 'success') {
        setOtpSent(true);
      } else {
        alert(data.message);
      }
    } catch {
      alert('Network error');
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch(apiUrl('verify_otp'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, otp }),
      });
      const data = await res.json();
      if (data.status === 'success') {
        if (!data.token || !data.admin) {
          alert('Invalid login response');
          setLoading(false);
          return;
        }
        setStoredAuth({ token: data.token, admin: data.admin });
        navigate('/dashboard', { replace: true });
      } else {
        alert(data.message);
      }
    } catch {
      alert('Network error');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ maxWidth: 380, mx: 'auto', mt: 8, p: 3, border: 1, borderColor: 'grey.300', borderRadius: 1 }}>
      <Typography variant="h5" gutterBottom>Admin Login</Typography>

      {!otpSent ? (
        <>
          <TextField
            label="Phone"
            fullWidth
            margin="normal"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            disabled={!phone || loading}
            onClick={requestOtp}
          >
            {loading ? <CircularProgress size={24} /> : 'Send OTP'}
          </Button>
        </>
      ) : (
        <>
          <Typography>OTP sent to {phone}</Typography>
          <TextField
            label="4-digit OTP"
            fullWidth
            margin="normal"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 4))}
            inputProps={{ maxLength: 4, inputMode: 'numeric' }}
          />
          <Button
            fullWidth
            variant="contained"
            disabled={otp.length !== 4 || loading}
            onClick={verifyOtp}
          >
            {loading ? <CircularProgress size={24} /> : 'Verify OTP'}
          </Button>
          <Button
            fullWidth
            sx={{ mt: 1 }}
            onClick={() => {
              setOtpSent(false);
              setOtp('');
            }}
          >
            Change Phone
          </Button>
        </>
      )}
    </Box>
  );
}
